/**
 * AI Space 专用：获取当前登录用户 & 当前团队信息
 *
 * 用法：
 *   import { useCurrentUser } from '../hooks/useCurrentUser'
 *
 *   const { userId, nickname, avatar, groupId, groupName, myRole } = useCurrentUser()
 *
 * myRole 说明：
 *   1 = 超级管理员
 *   2 = 管理员
 *   3 = 普通成员
 *  -1 = 尚未加载
 */

import { useSelector } from 'react-redux'
import { RootState } from '../../../app/store'

export interface CurrentUser {
  userId: string // 用户 ID
  nickname: string // 昵称
  avatar: string // 头像 URL
  mobile: string // 手机号
  groupId: string // 当前团队 ID
  groupName: string // 当前团队名称
  myRole: number // 当前用户在团队中的角色（1超管 2管理员 3成员）
  isVip: boolean // 当前团队是否开通 VIP
}

export function useCurrentUser(): CurrentUser {
  const user = useSelector((state: RootState) => state.main.user)
  const group = useSelector((state: RootState) => state.group)

  return {
    userId: user?.user_id ?? '',
    nickname: user?.nickname ?? '',
    avatar: user?.headimgurl ?? '',
    mobile: user?.mobile ?? '',
    groupId: group?.groupId ?? '',
    groupName: group?.groupName ?? '',
    myRole: group?.myRole ?? -1,
    isVip: group?.isVip ?? false
  }
}
